import { Button, Upload, Space, Empty, Image, message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { uploadMedia } from "../../lib/api/resources/media";
import { Media } from "@rumble-it/common-lib/types/models/Media.interface";

interface ImageUploadProps {
  value?: Media;
  onChange?: (value: Media | null) => void;
}

export const ImageUpload = ({ value, onChange }: ImageUploadProps) => {
  const uploadMutation = useMutation({
    mutationFn: ({
      file,
      onProgress,
    }: {
      file: File;
      onProgress?: (percent: number) => void;
    }) => {
      return uploadMedia(file, onProgress);
    },
    onError: () => message.error("Er is een fout opgetreden bij het uploaden"),
    onSuccess: (img) => onChange?.(img),
  });

  return (
    <Space align="start">
      {value ? (
        <Image width={240} src={value.contentUrl} />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Geen afbeelding"
        />
      )}
      <Space>
        <Upload
          accept="image/*"
          showUploadList={false}
          customRequest={(options) =>
            uploadMutation.mutate(
              {
                file: options.file as File,
                onProgress: (percent) => {
                  options.onProgress?.({ percent });
                },
              },
              {
                onError: () => options.onError?.(new Error("Upload mislukt")),
                onSuccess: (data) => options.onSuccess?.(data, options.file),
              },
            )
          }
        >
          <Button loading={uploadMutation.isPending}>
            Andere afbeelding kiezen
          </Button>
        </Upload>
        <Button danger disabled={!value} onClick={() => onChange?.(null)}>
          Verwijderen
        </Button>
      </Space>
    </Space>
  );
};
